"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginateCarousel = exports.compound = exports.chunk = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Sums all values, building from the previous
 * @param xs list of values to compound
 */
var compound = function compound(xs) {
  // @ts-expect-error  MIGRATE_STRICT_MODE
  return xs.reduce(function (p, n) {
    return p.concat((+p.slice(-1) || 0) + n);
  }, []);
};
/**
 * Build an array of offsets
 * @param viewport window width
 * @param values array of cell widths
 */


exports.compound = compound;

var chunk = function chunk(_ref) {
  var viewport = _ref.viewport,
      values = _ref.values;
  return values.reduce(function (acc, value) {
    var prev = acc[acc.length - 1];

    if (prev + value <= viewport) {
      acc[acc.length - 1] += value;
      return acc;
    }

    return [].concat(_toConsumableArray(acc), [value]);
  }, [0]);
};
/** Align last page to the left or right */


exports.chunk = chunk;

/**
 * Creates an array of offsets based on the given viewport
 * @param viewport window width
 * @param values array of cell widths
 * @param alignment align last page to the left or right
 */
var paginateCarousel = function paginateCarousel(_ref2) {
  var viewport = _ref2.viewport,
      values = _ref2.values,
      _ref2$alignment = _ref2.alignment,
      alignment = _ref2$alignment === void 0 ? "right" : _ref2$alignment;
  var offsets = chunk({
    viewport: viewport,
    values: values
  }); // Only a single page — no need to paginate

  if (offsets.length === 1) {
    return [0];
  } // Last page align right


  if (alignment === "right") {
    var edges = compound(offsets);
    var head = edges.slice(0, -2);
    var tail = edges[edges.length - 1] - viewport;
    return [0].concat(_toConsumableArray(head), [tail]);
  } // Last page align left


  var pages = compound(offsets).slice(0, -1);
  return [0].concat(_toConsumableArray(pages));
};

exports.paginateCarousel = paginateCarousel;
//# sourceMappingURL=paginate.js.map